var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { mobile: _vm.mobile }, attrs: { id: "map-component" } },
    [
      _c("div", { ref: "mapContainer", staticClass: "map-container" }),
      _vm._v(" "),
      _c("autocomplete-component", {
        ref: "autocomplete",
        attrs: {
          location: _vm.mapCenter,
          configuration: _vm.autocompleteConfig
        },
        on: {
          "select-item": _vm.selectItem,
          "clear-item": _vm.clearItem,
          editing: _vm.editing
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d89196c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d89196c","hasScoped":false,"transformToRequire":{"video":["demo","poster"],"source":"demo","img":"demo","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/components/map-component/src/MapComponent.vue
// module id = null
// module chunks = 